export default __webpack_public_path__ + "static/media/fortuner.e8dbaf0a.png";